const AlertWarning = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4.2 2.6 20.4h18.8L12 4.2Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
        <path d="M12 10.2v4.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        <circle cx="12" cy="17.5" r="0.85" fill="currentColor" />
    </svg>
)

export default AlertWarning;
